/* ---- contact form ---- */
class ContactForm extends HTMLElement {
  constructor() {
    (super(),
      (this.handleFormSubmit = this.handleFormSubmit.bind(this)),
      (this.handleFieldInput = this.handleFieldInput.bind(this)),
      (this.button = this.querySelector(".button")),
      (this.tnc = this.querySelector(".tnc-checkbox")));
  }
  connectedCallback() {
    ((this.form = this.querySelector("form")),
      this.form &&
        ((this.requiredFields = Array.from(
          this.querySelectorAll('.field-wrapper[data-required="true"]'),
        )),
        this.requiredFields.length > 0 &&
          (this.form.addEventListener("submit", this.handleFormSubmit),
          this.requiredFields.forEach((t) => {
            let e = t.querySelector(
              ".field__input, .text-area, .select__select",
            );
            e && e.addEventListener("input", this.handleFieldInput);
          }))));
  }
  disconnectedCallback() {
    (this.form &&
      this.form.removeEventListener("submit", this.handleFormSubmit),
      this.requiredFields.forEach((t) => {
        let e = t.querySelector(".field__input, .text-area, .select__select");
        e && e.removeEventListener("input", this.handleFieldInput);
      }));
  }
  handleFormSubmit(t) {
    this.button &&
      ((this.button.disabled = !0), this.button.classList.add("loading"));
    let e = !0;
    if (this.tnc && "true" !== this.tnc.dataset.checked) {
      e = !1;
      let i = document.querySelector(
        `.tnc-checkbox-warning--${tnc.dataset.warningPosition}-${tnc.dataset.section}`,
      );
      i && i.classList.remove("hidden");
    }
    if (
      (this.requiredFields.forEach((t) => {
        let i = t.querySelector(".field__input, .text-area, .select__select"),
          s = t.querySelector(".field-wrapper__error-msg");
        i &&
          !i.value.trim() &&
          ((e = !1),
          t.classList.add("field-wrapper--error"),
          s && s.classList.remove("hidden"));
      }),
      !e)
    )
      return (
        this.button &&
          ((this.button.disabled = !1),
          this.button.classList.remove("loading")),
        t.preventDefault(),
        t.stopImmediatePropagation(),
        !1
      );
  }
  handleFieldInput(t) {
    let e = t.target,
      i = e.closest(".field-wrapper"),
      s = i.querySelector(".field-wrapper__error-msg");
    (i.classList.remove("field-wrapper--error"),
      s && s.classList.add("hidden"));
  }
}
customElements.define("contact-form", ContactForm);
